import { LEAD_DROP_FORM_1_CONSTANTS } from "./leadDropForm_1";

/** Lead drop form variant 3 — inline “Drop a query” form on the page */
export const LEAD_DROP_FORM_3_CONSTANTS = {
  DEFAULT_ROW: {
    ...LEAD_DROP_FORM_1_CONSTANTS.DEFAULT_ROW,
    title: "Drop a Query",
    sub_text:
      "Fill out the form below and our team will get back to you shortly.",
    button_text: "Submit",
    button_color: "#8E7CC3",
    button_background_color: "#8E7CC3",
    success_title: "Thank you!",
    success_description: "Our team will get back to you shortly.",
  },
  LEAD_DROP_FORM_FIELDS_CONFIG:
    LEAD_DROP_FORM_1_CONSTANTS.LEAD_DROP_FORM_FIELDS_CONFIG,
  METADATA_FIELDS: [],
};
